import * as z from "zod";
import { zodSortField } from "../utils";

export const EnvironmentValues = ["PRELIVE", "PRODUCTION", "TEST"] as const;

export type Environment = (typeof EnvironmentValues)[number];

const brandRegex = /^[A-Za-zÀ-ÿ0-9\s-]{1,100}$/;
const codeRegex = /^[0-9]{1,20}$/;
const sivRegex = /^[A-Za-z0-9]{1,100}$/;

export const addIdentificationEnvSivSchema = z.object({
  environment: z.enum(EnvironmentValues),

  sivIdentifier: z.string().max(100).regex(sivRegex, "Format COD-SIV invalide"),

  marqueJnl: z.string().max(100).regex(brandRegex, "Format marque invalide"),

  codeConcentrateurJnl: z
    .string()
    .max(20)
    .regex(codeRegex, "Code concentrateur doit être numérique"),

  codePartenaireJnl: z
    .string()
    .max(20)
    .regex(codeRegex, "Code partenaire doit être numérique"),

  isActive: z.boolean(),
});

export const editIdentificationEnvSivSchema =
  addIdentificationEnvSivSchema.extend({
    id: z.number(),
  });

export const deleteIdentificationEnvSivSchema = z.object({
  id: z.number(),
});

export const getIdentificationEnvSivRequestSchema = z.object({
  sort: zodSortField(["environment"]),
});
